import {Grid} from '@primer/react-brand/esm'

import Styles from './ShowcaseSection.module.css'

import {Showcase, type ShowcaseProps} from '../../generic/Showcase/Showcase'

export type ShowcaseSectionProps = ShowcaseProps

export type ShowcaseSectionPropsData = Omit<ShowcaseSectionProps, 'productUI'>

export const defaultProps: Partial<ShowcaseSectionProps> = {}

export const ShowcaseSection = (props: ShowcaseSectionProps) => {
  const initializedProps: ShowcaseSectionProps = {...defaultProps, ...props}

  return (
    <div className={Styles['ShowcaseSection']}>
      <div className={Styles['ShowcaseSection__Spacer']} />
      <div className={Styles.ShowcaseSection__gridFrame}>
        <div className={Styles.ShowcaseSection__gridContent}>
          <Grid columnGap="none" rowGap="none" enableGutters={false}>
            <Grid.Column span={12} className={Styles.ShowcaseSection__gridColumn}>
              <Showcase {...initializedProps} />
            </Grid.Column>
          </Grid>
        </div>
      </div>
    </div>
  )
}
